/**
 * Trade schemas
 */
import { z } from "zod";
import { createEntityFilterSchema, NestedPaginationParamsSchema, PaginationMetaSchema, SortParamsSchema, StrapiFilterOps, StrapiIdSchema, } from "./common.schemas";
import { TradeRelationSchema } from "./relations";
// ============================================================================
// Input Schemas
// ============================================================================
/**
 * Trade type schema (direction)
 */
export const TradeTypeSchema = z.enum(["POSITION_TYPE_SELL", "POSITION_TYPE_BUY"]);
/**
 * Trade filters schema - typesafe filters for trade queries
 * Created using createEntityFilterSchema to reuse field types from TradeRelationSchema
 */
export const TradeFiltersSchema = createEntityFilterSchema(TradeRelationSchema, {
    scalars: ["type", "symbol", "state"],
    relations: ["bot_config"],
}).extend({
    // Timestamp uses number for range filters (milliseconds)
    timestamp: StrapiFilterOps(z.number()).optional(),
});
/**
 * Trade query params schema
 */
export const TradeQueryParamsSchema = NestedPaginationParamsSchema.merge(SortParamsSchema)
    .extend({
    filters: TradeFiltersSchema.optional(),
})
    .strict();
// ============================================================================
// Entity Schemas
// ============================================================================
/**
 * Trade schema - extends TradeRelationSchema with relations
 */
export const TradeSchema = TradeRelationSchema.extend({
    // Relations
    bot_config: z.object({ id: StrapiIdSchema }).nullish(),
});
/**
 * Bot trades response schema
 */
export const BotTradesResponseSchema = z.object({
    trades: z.array(TradeSchema),
    meta: z.object({
        pagination: PaginationMetaSchema,
    }),
});
